import type { Goal } from "instantdb/types";

export const HEART_GOALS: Partial<Goal>[] = [
  {
    id: "track-blood-pressure",
    title: "Track blood pressure",
    description: "Monitor your blood pressure regularly",
    symbol: "❤️",
  },
  {
    id: "heart-healthy-nutrition",
    title: "Heart-healthy nutrition",
    description: "Follow a diet rich in fruits, vegetables, and lean proteins",
    symbol: "🍎",
  },
  {
    id: "reduce-sodium-intake",
    title: "Reduce sodium intake",
    description: "Cut down on salt consumption to protect heart health",
    symbol: "🧂",
  },
];
